import { AlertCircle } from "lucide-react";
import { IMPORTANT_NOTE } from "@/lib/siteConfig";

/**
 * Subtle inline strip carrying the ethical 'we are not therapists' note.
 */
export default function ImportantNote({ className = "" }) {
  return (
    <div
      data-testid="important-note"
      className={`flex items-start gap-3 text-sm text-ink-muted leading-[1.7] bg-[rgba(74,63,57,0.04)] border border-[rgba(74,63,57,0.08)] rounded-xl p-4 ${className}`}
    >
      <AlertCircle className="w-4 h-4 mt-0.5 text-ink-muted shrink-0" aria-hidden="true" />
      <p className="max-w-3xl">
        <span className="text-[11px] uppercase tracking-[0.18em] font-semibold text-ink-muted mr-2">
          Note
        </span>
        {IMPORTANT_NOTE}
      </p>
    </div>
  );
}
